import axios from 'axios';
import ENV from '../constants/Environment.js';
export default new class LiveStreamService {

    async getVideo() {
        const response = await axios.get(`${ENV.HEROKU_API_ENDPOINT}/sermons/`);
        return response.data.results;
    }

}
